/* eslint-disable import/no-duplicates */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import Waterfall from "../../assets/waterfall-blog.jpg";
import Leaf from "../../assets/waterfall-blog.jpg";
import ApiRoutes from "../../config/api.routes";
import Trustee from "../../assets/Trustee1.png";
import Blog1_1 from "../../assets/blog1_1.jpg";
import Blog1_5 from "../../assets/blog1_5.png";
import Blog2_1 from "../../assets/blog2_1.jpg";
import Blog2_2 from "../../assets/blog2_2.png";
import Blog2_3 from "../../assets/blog2_3.png";
import Blog3_1 from "../../assets/blog3_1.jpg";
import Blog4_1 from "../../assets/blog3_1.jpg";
import Blog5_1 from "../../assets/blog5_1.jpg";
import Blog5_2 from "../../assets/blog5_2.png";
import Blog5_3 from "../../assets/blog5_3.png";
import Blog5_4 from "../../assets/blog5_4.png";
import HomeHero from "../../assets/home_hero.png";
import Palm from "../../assets/waterfall-blog.jpg";
import Valley from "../../assets/waterfall-blog.jpg";
import { EcoTokenStatus, HALVING_THRESHOLDS } from "../../utils/constants";
import { useEffect, useState } from "react";
import { Grid, Button, Box, Typography, styled, Modal, SvgIcon } from "@mui/material";
import ShareIcon from "../../assets/share_icon.svg";
import { FeaturedLand, ReelNumber } from "../../components";
import { LandToken } from "../../types/LandToken";
import { useAxios } from "../../services/http.service";
import {
  Public,
  EnergySavingsLeafOutlined,
  PublishedWithChangesOutlined,
  DocumentScannerOutlined,
  Timelapse,
} from "@mui/icons-material";
import { consoleError, toReadable } from "../../utils/methods";
import { WidgetGrid, BankWidget, convertParcelsToHectares } from "../EcoBank";
import PopUpGraph from "../../components/LineChart";
import { AppRoutes } from "../../config/app.routes";
import { useNavigate } from "react-router-dom";

// Type for the land parameter
type SimpleLandProps = {
  id?: string | number;
  name?: string;
  content?: string;
  location?: any; // Using any to handle both string and object
  ecoScore?: number;
  trustee?: string;
  guardian?: string;
  startingBid?: string | number;
  address?: string;
  minterId?: number;
  owner?: string;
  trustId?: number;
  status?: string;
  minterAddress?: string;
  mintingRate?: number;
  expiring?: Date;
  eftPool?: number;
  eftClaimed?: number;
  advanceIndicators?: any;
  createdAt?: Date | string;
  meta?: any; // Using any to avoid nested type issues
  etNft?: any; // Using any to avoid nested type issues
  trust?: any; // Using any to avoid nested type issues
};

// Simplified FeaturedLand component
const SimpleFeaturedLand = ({ land, showButton = true }: { land: SimpleLandProps; showButton?: boolean }) => {
  return (
    <Grid
      width="100%"
      flexDirection="column"
      display="flex"
      sx={{ borderLeft: 0, borderRight: 0, borderColor: "border.dark", backgroundColor: "transparent" }}
    >
      <HighlightedLand>
        <LandImage
          src={land.content || Waterfall}
          sx={{ borderRadius: { xs: "20px 20px 0px 0px", md: "20px 0px 0px 20px" } }}
        />
        <LandInfo
          sx={{
            p: { xs: 6, sm: 12 },
            borderRadius: { xs: "0px 0px 20px 20px", md: "0px 20px 20px 0px" },
            backgroundColor: "back.featureLandCard",
          }}
        >
          <LandInfoBlock sx={{ p: 0, border: 0 }}>
            <Typography
              variant="body2"
              color="text.disabled"
              fontFamily="'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
            >
              #{land.id}
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {land.meta?.name}
            </Typography>
            <Typography variant="body1" color="text.disabled">
              Kandy, Sri Lanka
            </Typography>
          </LandInfoBlock>

          <LandDetailsBlock>
            <LandInfoBlock>
              <Typography variant="body2">Status</Typography>
              <Typography
                variant="body1"
                fontWeight="bold"
                fontFamily="'IBM Plex Mono', monospace"
                color="action.pulse"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <PulseCircle />
                LIVE AUCTION
              </Typography>
            </LandInfoBlock>

            <LandInfoBlock sx={{ direction: "rtl" }}>
              <RightTextBox>
                <Typography variant="body2">Eco Score</Typography>
              </RightTextBox>
              <RightTextBox>
                <Typography variant="body1" fontWeight="bold" fontFamily="'IBM Plex Mono', monospace">
                  {land.ecoScore ? (land.ecoScore * 100).toFixed() : "85"}
                </Typography>
              </RightTextBox>
            </LandInfoBlock>

            <LandInfoBlock>
              <Typography variant="body2">Trustee</Typography>
              <Typography variant="body1" fontWeight="bold" fontFamily="'IBM Plex Mono', monospace">
                {land.trustee || "0x4b3...3b2c"}
              </Typography>
            </LandInfoBlock>

            <LandInfoBlock sx={{ direction: "rtl" }}>
              <RightTextBox>
                <Typography variant="body2">Guardian</Typography>
              </RightTextBox>
              <RightTextBox>
                <Typography
                  sx={{ textDecoration: "underline" }}
                  variant="body1"
                  fontWeight="bold"
                  fontFamily="'IBM Plex Mono', monospace"
                >
                  {land.guardian || "0x1a2...3b4c"}
                </Typography>
              </RightTextBox>
            </LandInfoBlock>

            <LandInfoBlock>
              <Grid container flexDirection="column" item width="auto">
                <Typography variant="body2" color="text.disabled">
                  Opening bid
                </Typography>
                <Typography variant="body1" fontWeight="bold" fontFamily="'IBM Plex Mono', monospace">
                  {land.startingBid || "5000"} USD
                </Typography>
              </Grid>
            </LandInfoBlock>

            <LandInfoBlock sx={{ direction: "rtl" }}>
              <Grid container flexDirection="column" item width="auto">
                <RightTextBox>
                  <Typography variant="body2" color="text.disabled">
                    Auction ends in
                  </Typography>
                </RightTextBox>
                <RightTextBox>
                  <Typography
                    sx={{ direction: "ltr" }}
                    variant="body1"
                    fontWeight="bold"
                    fontFamily="'IBM Plex Mono', monospace"
                  >
                    2 days 14 hours
                  </Typography>
                </RightTextBox>
              </Grid>
            </LandInfoBlock>
          </LandDetailsBlock>

          {showButton && (
            <Grid
              container
              flexDirection={{ xs: "column", sm: "row" }}
              alignItems="center"
              justifyContent="space-between"
              gap={2}
            >
              <Grid item xs={12} sm="auto">
                <ViewButton>View land</ViewButton>
              </Grid>
              <Grid item xs={12} sm="auto">
                <ResponsiveContainer>
                  <ShareButton>
                    <img src={ShareIcon} alt="share" />
                  </ShareButton>
                </ResponsiveContainer>
              </Grid>
            </Grid>
          )}
        </LandInfo>
      </HighlightedLand>
    </Grid>
  );
};

// PulseCircle component
const PulseCircle = () => (
  <Box
    sx={{
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: "action.pulse",
      marginRight: "8px",
      animation: "pulse 2s infinite",
      "@keyframes pulse": {
        "0%": { boxShadow: "0 0 0 0 rgba(32, 171, 43, 0.7)" },
        "70%": { boxShadow: "0 0 0 10px rgba(32, 171, 43, 0)" },
        "100%": { boxShadow: "0 0 0 0 rgba(32, 171, 43, 0)" },
      },
    }}
  />
);

// The widget values are underlined links. text-decoration can't reach into the reel's
// clipped digit cells, so the reel draws the 2px line itself (paint-only, no layout).
const reelUnderline = { boxShadow: "0 2px 0 currentColor" };

const TerminalView = () => {
  const axios = useAxios();
  const [indicatorsLoading, setIndicatorsLoading] = useState(true);
  const [scannedLands, setScannedLands] = useState(0);
  const [marketCap, setMarketCap] = useState(0);
  const [totalTrees, setTotalTrees] = useState(0);
  const [sizeToHalving, setSizeToHalving] = useState(0);
  const [totalParcels, setTotalParcels] = useState(0);
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [chartType, setChartType] = useState("price");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetchIndicators();
  }, []);
  const fetchIndicators = async () => {
    try {
      setIndicatorsLoading(true);
      const result = await axios.get(ApiRoutes.ecoBank.indicators.root).then((res) => res.data);
      setScannedLands(result.soldLands || 0);
      setTotalTransactions(result.totalTransactions || 0);
      const trees = result.tokens.reduce((acc: any, cur: any) => acc + toReadable(cur, cur !== "0", false), 0);
      const prices = result.prices.reduce((acc: any, cur: any) => acc + toReadable(cur, true, false), 0);
      const parcels = result.parcels.reduce((acc: any, cur: any) => acc + cur, 0);
      setMarketCap(prices);
      setTotalTrees(trees);
      setTotalParcels(convertParcelsToHectares(parcels));
      const nextThreshold =
        HALVING_THRESHOLDS.find((threshold) => threshold > parcels) ||
        HALVING_THRESHOLDS[HALVING_THRESHOLDS.length - 1];
      setSizeToHalving(convertParcelsToHectares(nextThreshold - parcels));
    } catch (e) {
      consoleError("Failed to fetch indicators", { e });
    } finally {
      setIndicatorsLoading(false);
    }
  };
  const handleOpen = (type: string) => {
    setChartType(type); // Update the chart type
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const navigate = useNavigate();

  return (
    <>
      <Grid container justifyContent="center">
        <WidgetGrid container item xs={12} sx={{ backgroundColor: "transparent" }}>
          <BankWidget
            sx={{
              width: "100%",
              height: { xs: "64px", md: "72px" },
              padding: { xs: "0 18px", md: "0 25px" },
              display: "flex !important",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#959A80", // Updated background color from Figma (Reference: fill_3HS7A4 / fill_X0Y9OA)
              borderTop: "none",
              borderRadius: { xs: "20px 20px 0px 0px", md: "20px 0px 0px 0px" },
              position: "relative",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Public sx={{ width: "25px", height: "25px", color: "black" }} />
              <Box
                sx={{
                  fontFamily: "IBM Plex Mono, monospace",
                  fontWeight: 700,
                  fontSize: "14px",
                  lineHeight: 1.3,
                  textTransform: "uppercase",
                  marginLeft: { xs: "21px", md: "20px" },
                  color: "black",
                }}
              >
                Market Cap.
              </Box>
            </Box>
            <Box
              className="BankWidget-value"
              style={{
                fontFamily: "IBM Plex Mono, monospace",
                fontWeight: 700,
                fontSize: "14px",
                lineHeight: 1.3,
                color: "black",
                textAlign: "right",
                cursor: "pointer",
              }}
              onClick={() => handleOpen("marketCap")}
            >
              {indicatorsLoading ? (
                "..."
              ) : (
                <ReelNumber
                  style={reelUnderline}
                  prefix={<span style={{ fontSize: "15px" }}>$</span>}
                  value={toReadable(marketCap, false, true, 0)}
                />
              )}
            </Box>
          </BankWidget>
          <BankWidget
            sx={{
              width: "100%",
              height: { xs: "64px", md: "72px" },
              padding: { xs: "0 18px", md: "0 25px" },
              display: "flex !important",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#959A80",
              borderTop: "none",
              position: "relative",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <EnergySavingsLeafOutlined sx={{ width: "25px", height: "25px", color: "black" }} />
              <Box
                sx={{
                  fontFamily: "IBM Plex Mono, monospace",
                  fontWeight: 700,
                  fontSize: "14px",
                  lineHeight: 1.3,
                  textTransform: "uppercase",
                  marginLeft: { xs: "21px", md: "20px" },
                  color: "black",
                }}
              >
                TR3 Mint Price
              </Box>
            </Box>
            <Box
              className="BankWidget-value"
              style={{
                fontFamily: "IBM Plex Mono, monospace",
                fontWeight: 700,
                fontSize: "14px",
                lineHeight: 1.3,
                color: "black",
                textAlign: "right",
                cursor: "pointer",
              }}
              onClick={() => handleOpen("price")}
            >
              {indicatorsLoading ? (
                "..."
              ) : (
                <ReelNumber
                  style={reelUnderline}
                  prefix={<span style={{ fontSize: "15px" }}>$</span>}
                  value={toReadable(marketCap / totalTrees || 0, false, true, 4)}
                />
              )}
            </Box>
          </BankWidget>
          <BankWidget
            sx={{
              width: "100%",
              height: { xs: "64px", md: "72px" },
              padding: { xs: "0 18px", md: "0 25px" },
              display: "flex !important",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#959A80",
              borderTop: "none",
              borderRadius: { xs: "0px 0px 0px 0px", md: "0px 20px 0px 0px" },
              position: "relative",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <PublishedWithChangesOutlined sx={{ width: "25px", height: "25px", color: "black" }} />
              <Box
                sx={{
                  fontFamily: "IBM Plex Mono, monospace",
                  fontWeight: 700,
                  fontSize: "14px",
                  lineHeight: 1.3,
                  textTransform: "uppercase",
                  marginLeft: { xs: "21px", md: "20px" },
                  color: "black",
                }}
              >
                Total Transactions
              </Box>
            </Box>
            <Box
              style={{
                fontFamily: "IBM Plex Mono, monospace",
                fontWeight: 700,
                fontSize: "14px",
                lineHeight: 1.3,
                color: "black",
                textAlign: "right",
                cursor: "pointer",
              }}
              onClick={() => navigate(AppRoutes.Transactions.path + "?currentFilter=all")}
              className="BankWidget-value"
            >
              {indicatorsLoading ? (
                "..."
              ) : (
                <ReelNumber style={reelUnderline} value={toReadable(totalTransactions, false, false, 0)} />
              )}
            </Box>
          </BankWidget>
          <BankWidget
            sx={{
              width: "100%",
              height: { xs: "64px", md: "72px" },
              padding: { xs: "0 18px", md: "0 25px" },
              display: "flex !important",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#959A80",
              borderTop: "none",
              borderRadius: { xs: "0px 0px 0px 0px", md: "0px 0px 0px 20px" },
              position: "relative",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <SvgIcon sx={{ width: "26px", height: "29px", color: "black" }} viewBox="0 0 26 29">
                <path
                  d="M13.0002 0.228L0.2 7.1582V21.3461L13.0002 28.6727L25.8 21.3461V7.1582L13.0002 0.228ZM23.6712 20.1048L14.0688 25.6127V22.027C13.612 22.1046 13.1466 22.1562 12.6639 22.1562C12.414 22.1562 12.1725 22.1391 11.9312 22.1132V25.6127L2.32881 20.1048V9.54575L5.55275 11.4508C5.82857 10.7957 6.19903 10.1837 6.65587 9.61477L3.50138 7.76153L12.9914 2.71045L22.4818 7.76153L20.3526 9.01134V11.4938L23.6539 9.53722V20.0963L23.6712 20.1048Z"
                  fill="black"
                  stroke="black"
                  strokeWidth="0.39"
                  strokeMiterlimit="10"
                />
                <path
                  d="M8.88062 10.6567C7.83764 11.6997 7.312 12.9668 7.312 14.4494C7.312 15.001 7.39825 15.5354 7.57926 16.044C7.76027 16.5612 8.00169 17.0439 8.29475 17.4921L7.67396 18.1127C7.50156 18.2851 7.42395 18.4833 7.42395 18.7074C7.42395 18.9315 7.51018 19.1298 7.67396 19.3022C7.84635 19.4746 8.04455 19.5522 8.26866 19.5436C8.49277 19.535 8.69097 19.4574 8.86336 19.3022L9.45806 18.7419C9.94938 19.0609 10.4582 19.3195 10.9926 19.5177C11.527 19.716 12.087 19.8107 12.6732 19.8107C14.1557 19.8107 15.4232 19.285 16.4661 18.242C17.5091 17.1991 18.0347 15.9319 18.0347 14.4494V9.088H12.6732C11.1906 9.088 9.92359 9.61375 8.88062 10.6567ZM16.3365 14.4494C16.3365 15.4665 15.9833 16.3371 15.2679 17.0439C14.5525 17.7593 13.6903 18.1127 12.6732 18.1127C12.3198 18.1127 11.975 18.0524 11.6475 17.9317C11.3199 17.8111 10.9925 17.6731 10.6736 17.5265L13.8887 14.3114C14.0611 14.139 14.1387 13.9408 14.1387 13.7081C14.1387 13.4754 14.0524 13.2684 13.8887 13.1047C13.7163 12.9323 13.5181 12.8548 13.294 12.8548C13.0699 12.8548 12.8717 12.9409 12.6993 13.1047L9.45806 16.3456C9.32877 16.0267 9.21682 15.7078 9.13062 15.3975C9.04442 15.0872 9.00141 14.7683 9.00141 14.4494C9.00141 13.4323 9.3546 12.5617 10.07 11.8549C10.7855 11.1394 11.6476 10.786 12.6647 10.786H16.3281V14.4494H16.3365Z"
                  fill="black"
                  stroke="black"
                  strokeWidth="0.39"
                  strokeMiterlimit="10"
                />
              </SvgIcon>
              <Box
                sx={{
                  fontFamily: "IBM Plex Mono, monospace",
                  fontWeight: 700,
                  fontSize: "14px",
                  lineHeight: 1.3,
                  textTransform: "uppercase",
                  marginLeft: { xs: "21px", md: "20px" },
                  color: "black",
                }}
              >
                EFTs
              </Box>
            </Box>
            <Box
              style={{
                fontFamily: "IBM Plex Mono, monospace",
                fontWeight: 700,
                fontSize: "14px",
                lineHeight: 1.3,
                color: "black",
                textAlign: "right",
                cursor: "pointer",
              }}
              onClick={() => navigate(AppRoutes.Lands.path + "?currentFilter=all")}
              className="BankWidget-value"
            >
              {indicatorsLoading ? "..." : <ReelNumber style={reelUnderline} value={scannedLands} />}
            </Box>
          </BankWidget>
          <BankWidget
            sx={{
              width: "100%",
              height: { xs: "64px", md: "72px" },
              padding: { xs: "0 18px", md: "0 25px" },
              display: "flex !important",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#959A80",
              borderTop: "none",
              position: "relative",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <DocumentScannerOutlined sx={{ width: "25px", height: "25px", color: "black" }} />
              <Box
                sx={{
                  fontFamily: "IBM Plex Mono, monospace",
                  fontWeight: 700,
                  fontSize: "14px",
                  lineHeight: 1.3,
                  textTransform: "uppercase",
                  marginLeft: { xs: "21px", md: "20px" },
                  color: "black",
                }}
              >
                TR3 Minted
              </Box>
            </Box>
            <Box
              className="BankWidget-value"
              style={{
                fontFamily: "IBM Plex Mono, monospace",
                fontWeight: 700,
                fontSize: "14px",
                lineHeight: 1.3,
                color: "black",
                textAlign: "right",
                cursor: "pointer",
              }}
              onClick={() => handleOpen("supply")}
            >
              {indicatorsLoading ? (
                "..."
              ) : (
                <ReelNumber style={reelUnderline} value={toReadable(totalParcels, false, true, 2)} />
              )}
            </Box>
          </BankWidget>
          <BankWidget
            sx={{
              width: "100%",
              height: { xs: "64px", md: "72px" },
              padding: { xs: "0 18px", md: "0 25px" },
              display: "flex !important",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#959A80",
              paddingBottom: "0 !important", // Override previous paddingBottom if needed, or just let height control it
              borderTop: "none",
              borderRadius: { xs: "0px 0px 20px 20px", md: "0px 0px 20px 0px" },
              position: "relative",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Timelapse sx={{ width: "25px", height: "25px", color: "black" }} />
              <Box
                sx={{
                  fontFamily: "IBM Plex Mono, monospace",
                  fontWeight: 700,
                  fontSize: "14px",
                  lineHeight: 1.3,
                  textTransform: "uppercase",
                  marginLeft: { xs: "21px", md: "20px" },
                  color: "black",
                }}
              >
                Ha Till Halving
              </Box>
            </Box>
            <Box
              className="BankWidget-value"
              style={{
                fontFamily: "IBM Plex Mono, monospace",
                fontWeight: 700,
                fontSize: "14px",
                lineHeight: 1.3,
                color: "black",
                textAlign: "right",
                cursor: "pointer",
              }}
              onClick={() => handleOpen("parcels")}
            >
              {indicatorsLoading ? (
                "..."
              ) : (
                <ReelNumber style={reelUnderline} value={toReadable(sizeToHalving, false, true, 2)} />
              )}
            </Box>
          </BankWidget>
        </WidgetGrid>
      </Grid>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ display: { md: "flex", sm: "none" }, alignItems: "center", justifyContent: "center" }}
      >
        <PopUpGraph onClose={handleClose} type={chartType} />
      </Modal>
    </>
  );
};

// Styled components
const HighlightedLand = styled("div")`
  display: grid;
  grid-template-columns: 50% 50%;
  justify-content: center;

  @media (max-width: 560px) {
    display: flex;
    flex-direction: column;
  }
`;

const LandImage = styled("img")`
  width: 100%;
  display: block;
  height: auto;
  margin: auto;
  height: 100%;
`;

const LandInfo = styled(Box)`
  background-color: ${({ theme }) => theme.palette.background.default};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1024px) {
    justify-content: space-between;
  }

  @media (max-width: 560px) {
    padding: 12px !important;
  }
`;

const LandInfoBlock = styled(Box)`
  padding: 24px 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette.border.default};
  align-items: end;

  &:nth-last-of-type(2),
  &:last-of-type {
    border-bottom: none;
  }

  @media (max-width: 850px) {
    padding: 12px 0;
  }

  &:nth-of-type(odd) {
    padding-right: 6px;
  }
`;

const LandDetailsBlock = styled(Box)`
  display: grid;
  grid-template-columns: 50% 50%;
  margin-bottom: 12px;
`;

const RightTextBox = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: end;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const ViewButton = styled(Button)`
  font-weight: 400;
  margin-top: 24px;
  width: 180px;
  height: 44px;
  @media (max-width: 1024px) {
    margin-top: 0;
  }
  @media (max-width: 992px) {
    width: 140px;
    height: 36px;
    font-size: 14px;
  }
  @media (max-width: 560px) {
    max-width: 100%;
    width: 100%;
  }
`;

const ShareButton = styled(Button)`
  font-weight: 400;
  margin-top: 24px;
  @media (max-width: 1024px) {
    margin-top: 0;
  }
  @media (max-width: 992px) {
    font-size: 14px;
  }
  @media (max-width: 560px) {
    max-width: 100%;
  }
`;

const ResponsiveContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @media (min-width: 992px) {
    width: 200px;
  }

  @media (max-width: 600px) {
    justify-content: center;
    flex-direction: row;
    align-items: center;
  }
`;

const LiveFeaturedLand = () => {
  const axios = useAxios();
  const [featuredNft, setFeaturedNft] = useState<LandToken | null>(null);
  useEffect(() => {
    const fetchFeaturedNft = async () => {
      const result = await axios
        .get(ApiRoutes.token.list + "?status=" + EcoTokenStatus.VERIFIED + "&limit=4")
        .catch((err) => err.response);
      if (result && result.status === 200 && result.data.length > 0) {
        const _auctions = result.data.filter((item: LandToken) => item.etNft?.etAuction.status === "started");
        const featured = _auctions[0] || result.data[0];
        setFeaturedNft(featured);
      }
    };
    fetchFeaturedNft();
  }, []);

  if (!featuredNft) {
    return null;
  }

  return <FeaturedLand blogStory={true} land={featuredNft as any} />;
};

export type Blog = {
  title: string;
  description: string;
  blog?: number;
  blogId?: string;
  category?: string;
  openInNew?: boolean;
};

type BlogCollection = {
  [key: string]: any;
};

export type BlogArticle = {
  id: number;
  documentId: string;
  Title: string;
  Slug: string;
  ButtonText: string;
  Thumbnail: {
    url: string;
    formats: {
      large: { url: string };
      medium: { url: string };
      small: { url: string };
      thumbnail: { url: string };
    };
  };
  blog: {
    id: number;
    documentId: string;
    Title: string;
    Description: string;
    Slug: string;
  };
  content: Array<{
    __component: string;
    id: number;
    text?: string;
    subId?: string;
    content?: string;
  }>;
};

// Function to fetch blog articles

// Export posters with dynamic content fetching
export const posters: BlogCollection = {
  "1": {
    blog: 1,
    title:
      " EFTs connect landowners with eco conscious investors looking to align their holdings with sustainable practices.",
    description: "Learn about how this process work.",
    path: "blog-article-1&subtitle=sub11",
    image: HomeHero,
    documentId: "txjiexnfxru23yo1640xn18g",
  },
  "2": {
    blog: 5,
    title:
      "EcoFutures have a marked difference from real estate-backed NFTs: they're pegged to the ecological value of a property, rather than its commercial value.",
    description: "Find out how we reframing investment values and supporting the planet's natural resources.",
    path: "blog-article-5&subtitle=sub51",
    image: Blog5_1,
    documentId: "iwmvrgzuwzhe2k9rxgth6zom",
  },
  "3": {
    blog: 3,
    title:
      " EFTs connect landowners with eco conscious investors looking to align their holdings with sustainable practices.",
    description: "Learn about how this process work.",
    path: "blog-article-3&subtitle=sub31",
    image: Blog3_1,
  },
  "4": {
    blog: 2,
    title:
      " EFTs connect landowners with eco conscious investors looking to align their holdings with sustainable practices.",
    description: "Learn about how this process work.",
    path: "blog-article-2&subtitle=sub21",
    image: Blog2_1,
  },
  "5": {
    blog: 4,
    title:
      " EFTs connect landowners with eco conscious investors looking to align their holdings with sustainable practices.",
    description: "Learn about how this process work.",
    path: "blog-article-4&subtitle=sub41",
    image: Leaf,
  },
};

// Export blogs with dynamic content fetching
export const blogs: BlogCollection = {
  "1": {
    blog: 1,
    documentId: "txjiexnfxru23yo1640xn18g",
    Slug: "blog-article-1",
  },
  "2": {
    blog: 2,
    documentId: "iwmvrgzuwzhe2k9rxgth6zom",
    Slug: "blog-article-2",
  },
  "3": {
    blog: 3,
    documentId: "gp9whbe049i67sm3obi9xd5p",
    Slug: "blog-article-3",
  },
  "4": {
    blog: 4,
    documentId: "yydr70wi6t9hnsf3n789q4n6",
    Slug: "blog-article-4",
  },
  "5": {
    blog: 5,
    documentId: "v3wqm7ytdsrrkkbe35st84cl",
    Slug: "blog-article-5",
  },
};

// Function to initialize blog content

enum ArticleContentType {
  image = "image",
  subtitle = "subtitle",
  paragraph = "paragraph",
  banner = "banner",
  glossary = "glossary",
}

type ArticleContentItem = {
  [ArticleContentType.image]?: {
    url: string;
    by?: string | JSX.Element;
    by2?: string | JSX.Element;
    title?: string;
    body?: string;
    width?: string;
    height?: string;
    color?: string;
    bodyColor?: string;
    small?: boolean;
  };
  [ArticleContentType.subtitle]?: string | { id: string; text: string };
  [ArticleContentType.paragraph]?: JSX.Element;
  [ArticleContentType.banner]?: {
    link?: string;
    linkText?: string;
    header?: string;
    body?: string;
    color?: string;
    by?: string;
    backgroundColor?: string;
    list?: JSX.Element;
    backgroundImage?: string;
  };
  [ArticleContentType.glossary]?: Array<{ term: string; definition: string }>;
};

export interface SupportArticle {
  title: string;
  thumbnail?: {
    url: string;
    by?: string;
  };
  blogId?: string;
  updated: string;
  category?: string;
  data?: ArticleContentItem[];
}

type ArticleCollection = {
  [key: string]: SupportArticle;
};

export const Articles: ArticleCollection = {
  "blog-article-1": {
    title: "From Seeds to TREEs: Understanding EcoFutures",
    category: "Terminal",
    blogId: "blog1",
    thumbnail: { url: Waterfall, by: "Himash Shavinda" },
    updated: "Feb 15, 2025",
    data: [
      { subtitle: { id: "summary", text: "Summary:" } },
      {
        paragraph: (
          <ul style={{ lineHeight: "2", textDecoration: "underline", textUnderlineOffset: "2px" }}>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub12");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              {" "}
              Turning Ecological Resources into Sustainable Investments
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub13");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Applying to be an EcoFutures Guardian
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub14");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Creating an EcoFutures Listing.{" "}
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub15");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              {" "}
              Land Verification: EcoFutures Trustees and the EcoScore.
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub16");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              NFTs + Land Contract = EcoFutures Tokens
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub17");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Investing in EcoFutures.
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub18");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              MetaMask Wallet.
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub19");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Minting Trees: The Green EcoFutures Currency.
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub110");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              EcoFutures: Bridging Ecology and Blockchain for a Greener Future
            </li>
          </ul>
        ),
      },
      {
        image: {
          url: Blog1_1,
          by: "Image by Himash Shavinda",
          title: "Understanding EcoFutures",
          body: "From Seeds to TREEs",
          bodyColor: "#2b3501",
        },
      },
      { subtitle: { id: "sub11", text: "Introduction" } },
      {
        paragraph: (
          <>
            EcoFutures reimagines the way we invest in nature by transforming conserved lands into a new digital asset
            class—EcoFutures Tokens (EFT). By leveraging blockchain innovation, EFTs are created from legally binding
            land stewardship contracts and rigorously verified by eco-specialists, ensuring that every token accurately
            reflects the intrinsic ecological value of a property. This approach not only provides landowners, or{" "}
            <a href="https://ecofutures.io/glossary?search=Guardians" target="blank" rel="noopener noreferrer">
              Guardians
            </a>
            , with a reliable source of funding to maintain and enhance their environments but also offers eco-conscious
            investors, known as{" "}
            <a href="https://ecofutures.io/glossary?search=Patrons" target="blank" rel="noopener noreferrer">
              Patrons
            </a>
            , a unique opportunity to generate returns as the land's ecological health improves. At its core, EcoFutures
            shifts the traditional focus from commercial development and resource extraction to conservation and
            long-term environmental stewardship. By integrating a scientific assessment method that produces an
            EcoScore—directly tied to the generation of a green currency called TREEs—EcoFutures creates a system where
            economic incentives align with the preservation and enhancement of our global commons. This innovative model
            provides a robust, transparent framework that bridges ecology and blockchain, paving the way for a
            sustainable investment paradigm.
          </>
        ),
      },
      {
        glossary: [
          { term: "Guardians", definition: "Owner of a land linked to an EFT." },
          { term: "Patron", definition: "Invester(s) in an EFT." },
        ],
      },
      {
        subtitle: {
          id: "sub12",
          text: "Turning Ecological Resources into Sustainable Investments",
        },
      },
      {
        paragraph: (
          <>
            Earth's ecological resources are irreplaceable and immensely valuable. TAn understanding of this fact,
            however, is not accurately reflected in today's world markets, which peg value to a land's commercial
            viability. Too often do investors ask how much they can extract from the land, or how much space they can
            "clear" to make room for their next development project.
          </>
        ),
      },
      {
        paragraph: (
          <>
            For owners of ecologically significant lands around the world who don't want to see yet another corporation
            purchase and destroy the natural environment, yet who also need financial support to upkeep their land,
            EcoFutures Tokens offers a solution. EFTs connect these landowners with eco conscious investors looking to
            align their holdings with sustainable practices.
          </>
        ),
      },
      {
        paragraph: (
          <>
            So how does this process work? How does a landowner (Guardian) turn their land into an on-chain asset (EFT)?
            How does EcoFutures accurately value these lands based on their ecological health? How do investors
            (Patrons) get involved, and what's in it for them? Let's start at the beginning.
          </>
        ),
      },
      { subtitle: { id: "sub13", text: "Applying to be an EcoFutures Guardian" } },
      {
        paragraph: (
          <>
            In order to become an EcoFutures Guardian, a landowner must first be referred to the platform by someone
            with an EcoFutures 'Guardian Account'. Once referred, they'll need to provide key information like the name
            listed on the land deed, their country code, and phone number to complete the application.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Uploading a land registration deed or a legally binding lease agreement is a recommended step for
            verification and EcoFutures guarantees the safety and confidentiality of all submitted documents. However,
            if the landowner doesn't wish to upload their deeds, there is the option to submit them to an EcoFutures
            Trustee in person.
          </>
        ),
      },
      {
        subtitle: {
          id: "sub14",
          text: "Creating an EcoFutures Listing",
        },
      },
      {
        paragraph: (
          <>
            The next step in the process is listing the land as an EFT on the EcoFutures platform. This listing is what
            potential investors will see on the <a href="/terminal">EcoFutures marketplace</a>, so it's important to
            create an accurate and attractive representation of the land.
          </>
        ),
      },
      {
        paragraph: (
          <>
            <SimpleFeaturedLand
              showButton={false}
              land={{
                id: "001",
                address: "0xabcdef1234567890",
                minterId: 123,
                owner: "0xabcdef1234567890",
                trustId: 789,
                status: EcoTokenStatus.VERIFIED,
                minterAddress: "0x1234567890abcdef",
                content: "https://images.unsplash.com/photo-1502082553048-f009c37129b9?q=80&w=1000",
                mintingRate: 0.05,
                expiring: new Date(Date.now() + 31536000000),
                ecoScore: 0.85,
                eftPool: 1000,
                eftClaimed: 200,
                advanceIndicators: {},
                createdAt: new Date(),
                meta: {
                  name: "EcoFutures Forest",
                  description: "A beautiful forest land with diverse ecosystem",
                  bfd_plan: "Sustainable forestry management",
                  basicPerks: ["hiking", "camping"],
                  startingBid: "5000000000",
                  ecoSystemType: "forest",
                  location: '{"lat":7.280280114022986,"lon":80.72728832812959,"name":"Kandy","country":"Sri Lanka"}',
                  size: "100",
                  elevationMin: "800",
                  elevationMax: "1200",
                  biomes: ["temperate forest"],
                  flora: ["oak", "pine"],
                  fauna: ["deer", "fox"],
                  dwellings: ["cabin"],
                  production: ["berries"],
                  easements: [],
                  contractPeriod: 10,
                  deed: "sample-deed.pdf",
                  survey: "sample-survey.pdf",
                  additional_contacts: [],
                },
                etNft: {
                  id: 123,
                  tokenId: 123,
                  minterAddress: "0x1234567890abcdef",
                  ownerAddress: "0xabcdef1234567890",
                  status: "live",
                  createdAt: new Date().toISOString(),
                  updatedAt: new Date().toISOString(),
                  redemptionsTotal: [],
                  rewardsCollectable: null,
                  etAuction: {
                    id: 456,
                    nftId: 123,
                    currency: "USD3",
                    status: "started",
                    auctionStart: new Date().toISOString(),
                    duration: 604800000, // 7 days in milliseconds
                    startingPrice: "10000000000",
                    endingPrice: "15000000000",
                    auctionEnd: new Date(Date.now() + 604800000).toISOString(),
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString(),
                    bids: [],
                    winner: null,
                  },
                },
                trust: {
                  id: 789,
                  address: "0xabcdef1234567890",
                  name: "EcoTrust Alliance",
                  organization: {
                    name: "EcoTrust Alliance",
                  },
                },
              }}
            />
          </>
        ),
      },
      {
        paragraph: (
          <>
            Listings on EcoFutures contain many details, including the land's name, size, location, category (forest,
            mountain, river, etc), and elevation range. These listings must also include descriptions of any plant and
            animal life on the land, identification of any built structures such as cabins or campsites, and information
            on any produce grown on the land–as well as easement rights provided to investors, such as produce yields or
            access to accommodations on the land. Photos and videos of the land should also be included to give
            potential investors a look at the natural environment.
          </>
        ),
      },
      {
        subtitle: {
          id: "sub15",
          text: "Land Verification: EcoFutures Trustees and the EcoScore",
        },
      },
      {
        paragraph: (
          <>
            Once a land is listed, it must be verified by an EcoFutures{" "}
            <a href="https://ecofutures.io/glossary?search=Trustees" target="blank" rel="noopener noreferrer">
              Trustee.
            </a>{" "}
            This process involves an initial verification to confirm land ownership and the accuracy of all submitted
            documents, as well as a visit to the land followed by biannual checks to assess its ecological health.
          </>
        ),
      },
      {
        glossary: [
          { term: "Trustee", definition: "A verified eco specialist, who will evaluated and verify the land" },
        ],
      },
      {
        paragraph: (
          <>
            In order to determine a land's ecological health, our Trustees conduct a scientific assessment of its key
            environmental factors (earth, water, air, biodiversity, community). The land's final grade, called an
            EcoScore, is calculated by the EcoFutures Trustee based on these environmental factors.
          </>
        ),
      },
      // {
      //   image: (
      //     { url: Blog1_3, by: "Image of EcoScore", small: true }
      //   ),
      // },
      {
        paragraph: (
          <>
            <LiveFeaturedLand />
          </>
        ),
      },
      {
        paragraph: (
          <>
            This EcoScore is directly connected to the value of an EFT, which encourages Guardians to not only maintain,
            but continually improve the ecological health of their land. Dive deeper into the EcoScore grading process
            by reading our <a href="/help?blog=blog-article-4&subtitle=sub42"> blog on the subject.</a>
          </>
        ),
      },
      {
        subtitle: {
          id: "sub16",
          text: "NFTs + Land Contract = EcoFutures Tokens",
        },
      },
      {
        paragraph: (
          <>
            The final step in bringing a land on-chain is for the Guardian to sign a contract in their country, which
            legally requires them to follow applicable environmental laws and maintain the ecological health of their
            land. These contracts are then wrapped into the land NFT on chain, creating the EcoFutures Token (EFT).
          </>
        ),
      },
      {
        subtitle: {
          id: "sub17",
          text: "Investing in EcoFutures",
        },
      },
      {
        paragraph: (
          <>
            Becoming a EcoFutures Patron is a simple yet exciting process! Potential investors can head over to the{" "}
            <a href="/terminal">EcoFutures marketplace</a> and begin browsing the currently available lands.Each land's
            individual listing will include the details mentioned above, as well as its EcoScore and notes about its
            environmental health.All of this information is provided to help investors identify the land(s) that best
            meet their criteria and make well-informed decisions based on a genuine and trustworthy representation of
            the property.
          </>
        ),
      },
      {
        paragraph: (
          <>
            <TerminalView />
          </>
        ),
      },
      {
        subtitle: {
          id: "sub18",
          text: "MetaMask Wallet",
        },
      },
      {
        paragraph: (
          <>
            Transactions on EcoFutures are handled in TREE coin and USDT, using Metamask–a crypto wallet and gateway to
            blockchain apps trusted by over 100 million users worldwide. If you prefer to pay by card, that's also an
            option. We are proud to partner with Moonpay: a fintech company that allows users from more than 150
            countries to easily buy and swap over 100 cryptocurrencies.
          </>
        ),
      },
      {
        subtitle: {
          id: "sub19",
          text: "Minting Trees: The Green EcoFutures Currency",
        },
      },
      {
        paragraph: (
          <>
            This Fibonacci halving mechanism increases the amount of green land on the EcoFutures protocol required to
            continue generating TREEs at the same rate, createing long-term scarcity of supply and making TREEs grow in
            value over time. The exact formula used to determine the TREE minting rate is as follows:
          </>
        ),
      },
      {
        image: { url: Blog1_5, color: "transparent", small: true },
      },
      {
        paragraph: (
          <>
            So, as a land's EcoScore rises over time, the amount of TREEs minted also rises. Ten percent of those TREEs
            are awarded to the land Guardian, giving them an additional incentive to continue improving the ecology of
            their EFT, while 90% of the minted TREEs are awarded to Patrons, serving as a bountiful and steady stream of
            ROI.
          </>
        ),
      },
      {
        subtitle: {
          id: "sub110",
          text: "EcoFutures: Bridging Ecology and Blockchain for a Greener Future",
        },
      },
      {
        paragraph: (
          <>
            Ours is a vision for a world where technology and nature work together, turning investment into a powerful
            force for ecological renewal. By reframing how investment values and supports the planet's natural
            resources, EcoFutures empowers individuals to contribute to a greener, more sustainable future. By
            harnessing the transparency and efficiency of blockchain to protect vital ecosystems, EcoFutures creates a
            new paradigm in which economic growth and environmental stewardship go hand in hand, offering hope for a
            thriving planet–and thriving wallets.
          </>
        ),
      },
    ],
  },
  "blog-article-2": {
    title: "The EcoFutures Trustees—people and organizations whose life's mission is to protect the planet",
    category: "Terminal",
    blogId: "blog2",
    thumbnail: { url: Trustee, by: "Forrest Cavale" },
    updated: "Sep 15, 2024",
    data: [
      { subtitle: { id: "summary", text: "Summary:" } },
      {
        paragraph: (
          <ul>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub22");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Who are EcoFutures Trustees?
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub23");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Getting the EcoFutures Trustee status
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub24");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              {" "}
              The role of an EcoFutures Trustee; perks and duties
            </li>
          </ul>
        ),
      },
      {
        image: {
          url: Blog2_1,
          by: "Image by Allan Cabello",
          title: "The EcoFutures Trustees",
          body: "People and organizations whose life's mission is to protect the planet",
          bodyColor: "#2b3501",
        },
      },
      { subtitle: { id: "sub21", text: "Introduction" } },
      {
        paragraph: (
          <>
            EcoFutures are green asset-backed NFTs that bring the ecological value of nature-abundant properties
            on-chain, allowing landowners and investors to generate capital gains while nurturing precious environmental
            assets. Trust and transparency are key parts of this process, which is why we work with qualified EcoFutures
            Trustees<sup>[1]</sup> to evaluate and verify the lands listed on the EcoFutures platform for bidding,
            investment, and conservation.
          </>
        ),
      },
      {
        glossary: [
          {
            term: "Trustee",
            definition: "Certified entities, that serve as third-party validators, as well as real- world oracles",
          },
        ],
      },
      { subtitle: { id: "sub22", text: "Who are EcoFutures Trustees?" } },
      {
        paragraph: (
          <>
            For a land to be approved as an EFT, it must have its ecological value scientifically assessed and be given
            an EcoScore rating. These assessments are carried out by EcoFutures Trustees: respected entities within the
            environmental conservation sphere that serve as third-party validators, as well as real world oracles
            feeding accurate ecological data into the EcoFutures blockchain.
          </>
        ),
      },
      {
        paragraph: (
          <>
            One of the prominent organizations serving as an EcoFutures Trustee is the{" "}
            <a href="https://analogforestry.org/" target="_blank" rel="noopener noreferrer">
              International Analog Forestry Network.
            </a>{" "}
            This network includes{" "}
            <a
              href="https://www.linkedin.com/in/ranil-senanayake-7a097313?originalSubdomain=lk"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              Dr. Ranil Senanayake
            </a>
            , a UC Davis graduate and systems ecologist, renowned for originating the concept and science of analog
            forestry<sup>[1]</sup>. Dr. Senanayake has designed numerous forests globally and established the first
            Analog Forest at the{" "}
            <a
              href="https://analogforestry.org/projects/belipola-arboretum-sri-lanka/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Belipola Training Center
            </a>{" "}
            in Sri Lanka. His extensive experience in ecological systems, along with his global training sessions is a
            prime example of the calibre of expertise we require EcoFutures Trustees to bring to the table in order to
            be selected for this important role.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Another key trustee is the
            <a href="https://rainforestprotectors.org/rainforest/index.aspx" target="_blank" rel="noopener noreferrer">
              {" "}
              Rainforest Protectors
            </a>{" "}
            Sri Lanka. This organization is a leading conservation entity in Sri Lanka, emphasizing the importance of
            preserving rainforests through active involvement and advocacy. By working with trustees who are
            knowledgeable and genuinely passionate about environmental conservation, EcoFutures can promise not only
            transparency but an accurate evaluation for landowners and a fair return to investors.
          </>
        ),
      },
      { subtitle: { id: "sub23", text: "Getting the EcoFutures Trustee status" } },
      {
        paragraph: (
          <>
            Our Trustees play a huge role in maintaining the integrity and reliability of the EcoFuture platform, which
            is why we take such great care in selecting which individuals and organizations can join the team.To be
            considered for an EcoFutures Trustee position, candidates must meet the following eligibility criteria:
            <ul style={{ marginTop: "40px" }}>
              <li style={{ textDecoration: "none" }}>
                Candidates must be ecological organizations, qualified ecological assessors, or international ecological
                bodies.
              </li>
              <li style={{ textDecoration: "none" }}>
                Candidates must have at least five years of operational experience in the field.
              </li>
              <li style={{ textDecoration: "none" }}>
                Organizations and individuals must provide proof of address through bills or registration documents.
              </li>
              <li style={{ textDecoration: "none" }}>
                Each verifier within the organization must submit proof of ID and have a connected digital wallet to
                receive payments.
              </li>
              <li style={{ textDecoration: "none" }}>
                Applicants need to provide detailed contact information, including the organization's name, email,
                website, and phone number.
              </li>
            </ul>
          </>
        ),
      },
      {
        banner: {
          link: "/",
          linkText: "Get started",
          header: "Interested in becoming an EcoFutures Trustee?",
          body: "The application process can be completed online.",
          color: "#ffffff",
          backgroundColor: "#955027",
          backgroundImage: Blog2_2,
          by: "Image by Santiago Chiva",
        },
      },
      {
        subtitle: {
          id: "sub24",
          text: "The role of an EcoFutures Trustee; perks and duties",
        },
      },
      {
        paragraph: (
          <>
            EcoFutures Trustees are responsible for conducting detailed scientific analyses of EFT lands and assessing
            various ecological factors to determine their values. This role is crucial as it provides trustworthy
            evidence that the lands listed on EcoFutures are genuinely sustainable and beneficial for environmental
            conservation, which in turn gives investors confidence to support legitimate and environmentally impactful
            lands.
          </>
        ),
      },
      {
        paragraph: (
          <>
            EcoFutures Trustees are responsible for calculating the EcoScore<sup>[1]</sup> of an EFT land by taking into
            consideration key ecological factors such as soil health, water quality and availability, air quality,
            biodiversity, and community.{" "}
            <a href="/support-center?blog=blog-article-4">
              Read more about how EcoScores<sup>[1]</sup> are tested and determined.
            </a>
          </>
        ),
      },
      {
        glossary: [
          {
            term: "EcoScore",
            definition: "Final grade assessment of a lands key environmental factors.",
          },
        ],
      },
      {
        paragraph: (
          <>
            EcoFutures Trustees are compensated each time they verify a land, with the payment amount varying based on
            the land size and the complexity of each case. This financial incentive gives Trustees the ability to
            comfortably complete the land verification process in a thorough and scientifically accurate manner.
          </>
        ),
      },
      {
        paragraph: (
          <>
            To minimize validation costs and avoid unnecessary carbon emissions from travel, we utilize local networks
            of Trustees in each country that EcoFutures holds lands. This also ensures that Trustees are working the
            biomes in which they hold the highest levels of expertise.
          </>
        ),
      },
      {
        paragraph: (
          <>
            If a trustee should act nefariously, EcoFutures will reassign the assets they manage to another trustee
            within the same local network.
          </>
        ),
      },
      {
        subtitle: {
          id: "sub25",
          text: "Outro",
        },
      },
      {
        paragraph: (
          <>
            In the backdrop of unprecedented climate change, becoming an EcoFutures Trustee is a commitment to
            environmental stewardship and directly influencing the sustenance of living ecologies. For ecologists,
            environmentalists, and sustainability experts, it's a great way to place their knowledge in the service of
            nature while also earning additional income and being a part of the future of green currencies.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Wondering how much you can help the planet as an EcoFutures Trustee? Read this research paper to understand
            why protecting ecological assets that are carbon sinks is the ultimate climate action you can take.
          </>
        ),
      },
      {
        banner: {
          link: "/",
          linkText: "See the research",
          header: "Wondering how much you can help the planet as an EcoFutures Trustee?",
          body: "Read this research paper to understand why protecting ecological assets that are carbon sinks, is the ultimate climate action you can take.",
          color: "#955027",
          backgroundColor: "#dbc4ba",
          backgroundImage: Blog2_3,
          by: "Image by Quang Nguyen Vinh",
        },
      },
    ],
  },
  "blog-article-3": {
    title: "A Paradigm Shift Toward Conscious Eco Capitalism",
    updated: "Sep 11, 2024",
    blogId: "blog3",
    category: "EcoFutures",
    thumbnail: { url: Palm, by: "Hans Eiskonen" },
    data: [
      { subtitle: { id: "summary", text: "Summary:" } },
      {
        paragraph: (
          <>
            <ul>
              <li
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const element = document.getElementById("sub32");
                  if (element) {
                    const elementRect = element.getBoundingClientRect();
                    const absoluteElementTop = elementRect.top + window.pageYOffset;
                    window.scrollTo({
                      top: absoluteElementTop - 40, // Changed to fixed 40px offset
                      behavior: "smooth",
                    });
                  }
                }}
              >
                Claiming Your Stake in the Global Commons
              </li>
              <li
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const element = document.getElementById("sub33");
                  if (element) {
                    const elementRect = element.getBoundingClientRect();
                    const absoluteElementTop = elementRect.top + window.pageYOffset;
                    window.scrollTo({
                      top: absoluteElementTop - 40, // Changed to fixed 40px offset
                      behavior: "smooth",
                    });
                  }
                }}
              >
                How EcoFutures Value Ecology
              </li>
            </ul>
          </>
        ),
      },
      {
        image: {
          url: Blog3_1,
          by: "Image by Asiri Dissanayaka",
          title: "A Paradigm Shift Toward Conscious Eco Capitalism",
          body: " ",
          bodyColor: "#4b4002",
        },
      },
      { subtitle: { id: "sub31", text: "Introduction" } },
      {
        paragraph: (
          <>
            EcoFutures Tokens (EFT) are a new green asset-class that link on-chain investments to the ecological value
            of real-world lands, such as rainforests in Sri Lanka or mature fruit forests in Costa Rica. By facilitating
            a transparent, immutable, and tamper-proof source of ecological investment, EFTs give the Guardians of these
            lands access to a consistent source of funds to sustain and improve natural ecosystems around the world,
            while also giving Patrons a promising long-term investment vehicle that will increase in value as a land's
            ecological health increases over time.
          </>
        ),
      },
      { subtitle: { id: "sub32", text: "Claiming Your Stake in the Global Commons" } },
      {
        paragraph: (
          <>
            It may seem obvious, but it's worth stating that many of the most precious resources on our planet form a
            finite, shared pool. This shared pool, also referred to as the Global Commons, includes limited yet
            essential resources such as oxygen, the Earth's atmosphere, the high oceans, and ice sheets, to name a few.
            While short-sighted corporate interest focuses on extracting or eliminating ecological resources in the name
            of development and profit, those who invest in EcoFutures Tokens understand that the paradigm must shift to
            environmental stewardship.
          </>
        ),
      },
      {
        paragraph: (
          <>
            EFTs are legally-binding land easements (or lease agreements) wrapped up as NFT smart contracts, which allow
            Patrons to hold a stake in a land's ecology–in its share of resources in the Global Commons<sup>[1]</sup>.
            As Guardians use funds from the EcoFutures platform to improve the EcoScore of their lands, the Global
            Commons<sup>[1]</sup> will steadily be replenished with cleaner water sources, richer soil, more carbon
            sinks in the form of forests, and higher degrees of biodiversity
          </>
        ),
      },
      {
        glossary: [
          {
            term: "Global Commons",
            definition:
              "Natural resources and areas that are not owned by any one nation but are shared and managed collectively",
          },
        ],
      },
      { subtitle: { id: "sub33", text: "How EcoFutures Value Ecology" } },
      {
        paragraph: (
          <>
            In the current world market, where value is often determined by commercial viability, EcoFutures offers a
            new way to shift investment emphasis to a land's ecological value. Doing this requires a much more
            sophisticated approach than merely looking at a land's photosynthetic biomass, as is commonly the case with
            schemes like carbon credits.
          </>
        ),
      },
      {
        paragraph: (
          <>
            In order to assess the ecological value of a land in a scientific and trustworthy way, EcoFutures brings in
            Trustees from respected entities within the environmental conservation sphere, such as Rainforest Protectors
            Sri Lanka, to conduct a thorough investigation of the land's key ecological indicators. This initial land
            assessment is only the beginning, however; the health of each land on the EcoFutures platform is analysed by
            our trustees twice per year in order to accurately measure value changes over time.
          </>
        ),
      },
      {
        paragraph: (
          <>
            During each of these assessments, EcoFutures Trustees use a proprietary scientific method to assign a land's
            EcoScore. This EcoScore provides an accurate rating of a land's ecological value based on a variety of key
            environmental indicators, including Soil, Air, Water, Biodiversity, and Community.
          </>
        ),
      },
      {
        banner: {
          link: "/support-center?blog=blog-article-4&subtitle=sub42",
          linkText: "Get Started",
          header: "Decoding the Ecoscore.",
          body: "Full breakdown of the individual components and testing methods that are involved in determining a land's EcoScore.",
          color: "#ffffff",
          backgroundColor: "#b0a040",
        },
      },
      {
        subtitle: {
          id: "sub33",
          text: "The voluntary carbon market has long faced a trust issue, and EcoFutures offer a solution.",
        },
      },
      {
        paragraph: (
          <>
            For more than a decade, the quality and efficacy of the existing carbon credit supply have been met with
            skepticism. Due to a lack of transparency in this space, the credibility of climate benefits and carbon
            offsetting claims have been undermined, reducing the amount of public trust in such schemes. EcoFutures uses
            blockchain applications and asset tokenisation to address this problem, allowing EFTs to garner the highest
            levels of trust, unlike traditional carbon markets. Trust is fundamentally designed into the EFT protocol,
            where vetted ecological organisations act as Trustees (oracles) that enforce, encrypt, and maintain the
            integrity of this transparent, immutable, and anti-climate change protocol.{" "}
          </>
        ),
      },
      {
        subtitle: {
          id: "sub34",
          text: "EcoFutures are more than just investment vehicles—they are tools for real change.",
        },
      },
      {
        paragraph: (
          <>
            Amid a growing crypto movement that calls for more meaningful investment, EcoFutures is the necessary
            catalyst for bringing our collective into the new paradigm of conscious eco capitalism.In an era of
            unprecedented and drastic climate change, few causes are as dire as those with the potential to affect
            substantial positive change for the Earth's most precious ecological resources.With EcoFutures, crypto
            investors can play a substantial role in the green revolution and take steps toward the possibility of a
            utopian future, where every inch of land turns into a forest garden of Eden.
          </>
        ),
      },
      {
        banner: {
          link: "/",
          linkText: "Get Started",
          header: "Considering buying your own EFT?",
          body: "Learn about the key reasons why EFTs are poised to appreciate within the next decade, making them one of the most important investments you can make if you're personally aligned with the urgent need for protecting Earth's essential ecologies.",
          color: "#ffffff",
          backgroundColor: "#2b3501",
        },
      },
    ],
  },
  "blog-article-4": {
    title: "How lands are verified and valued: Decoding the Ecoscore",
    blogId: "blog4",
    thumbnail: {
      url: Leaf,
      by: "Uwe Jelting",
    },
    category: "Terminal",
    updated: "Sep 11, 2024",
    data: [
      { subtitle: { id: "summary", text: "Summary:" } },
      {
        paragraph: (
          <ul>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub42");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Breaking Down the EcoScore
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub43");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Soil health—the foundation of ecosystem integrity
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub44");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Water quality and availability create the potential for life
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub45");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Air and forest health; the central factor in carbon sequestration
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub46");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Biodiversity: a key indicator of ecological health
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub47");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Community: the people keeping ecologies alive
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub48");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              EcoScore brings transparent proof of value to investors and landowners
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub49");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              EFTs are more than just investment vehicles...
            </li>
          </ul>
        ),
      },
      {
        image: {
          url: Leaf,
          height: "100%",
          by: "Image by Uwe Jelting",
          title: "How lands are verified and valued",
          body: "Decoding the Ecoscore",
          bodyColor: "#020202",
        },
      },
      { subtitle: { id: "sub41", text: "Introduction" } },
      {
        paragraph: (
          <>
            EcoFutures TREEs (EFT) are green asset-backed NFTs representing stakes in real-world lands that host living
            ecologies. With EFTs, you can directly invest in natural environments because the underlying asset they
            represent is the ecological value of a land parcel, not its commercial value. The secret sauce of this
            mechanism? The EcoScore—a rating of a land's real ecological value in terms of five key components: Soil,
            Air, Earth, Biodiversity, and Community.
          </>
        ),
      },
      {
        image: {
          url: Blog4_1,
          color: "transparent",
          small: true,
          by: "Image by Turr Tisseghem",
          by2: "Image by Kanish Karanasinghe",
        },
      },
      { subtitle: { id: "sub42", text: "Breaking Down the EcoScore" } },
      {
        paragraph: (
          <>
            When determining a land's ecological value, there are many more factors to consider than just the available
            photosynthetic biomass (which is the sole consideration in schemes like Carbon Credits). In the holistic
            approach of assessing a land's EcoScore, EcoFutures Trustees carry out a thorough and scientific analysis of
            factors like air quality, water purity, soil health, species diversity, and more.
          </>
        ),
      },
      {
        paragraph: (
          <>
            This detailed evaluation mechanism was developed by Dr. Ranil Senanayake, a UC Davis graduate and systems
            ecologist, renowned for originating the concept and science of Analog Forestry<sup>[1]</sup>. Dr. Ranil's
            organization,{" "}
            <a href="https://analogforestry.org/" target="_blank" rel="noopener noreferrer">
              Analog Forestry Network International
            </a>{" "}
            , is based in Sri Lanka and also serves as an EcoFutures Trustee.
          </>
        ),
      },
      {
        paragraph: (
          <>
            You can learn more about the role of EcoFutures Trustees by reading our story,{" "}
            <a href="/support-center?blog=blog-article-2">"The EcoFutures Trustees".</a>
          </>
        ),
      },
      {
        glossary: [
          {
            term: "Analog Forestry",
            definition: "A sustainable agroforestry practice that aims to restore and enhance biodiversity",
          },
        ],
      },
      {
        paragraph: (
          <>
            There's a lot of testing and observation required to arrive at a numerical EcoScore, so let's unpack how
            each key factor is addressed and assessed by our EcoFutures Trustees.
          </>
        ),
      },
      { subtitle: { id: "sub43", text: "Soil health—the foundation of ecosystem integrity" } },
      {
        paragraph: (
          <>
            Soil health is a key determiner of a land's ecological health and potential, but this seemingly simple
            concept is incredibly deep. To properly assess the health of a land's soil, we take into consideration
            things like soil structure and quality, topsoil depth, density, and chemical composition. High-scoring lands
            are nutrient-rich with deep topsoil, ensuring strong plant life and ecosystem sustainability—prime real
            estate for your green portfolio. Another important factor we examine is soil biology, or the presence and
            activity of organisms like microbes and earthworms, which are crucial for soil health. Abundant microbial
            and macrofaunal activity indicates a thriving ecosystem, making sure that the EcoScore reflects long-term
            ecological health.
          </>
        ),
      },
      { subtitle: { id: "sub44", text: "Water quality and availability create the potential for life" } },
      {
        paragraph: (
          <>
            Water is the lifeblood of any ecosystem, so we assess its quality and availability meticulously. We factor
            the type and flow of water sources, from periodic streams to perennial rivers. Robust, flowing water sources
            earn high scores, indicating resilient, well-hydrated ecosystems.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Water quality is also determined through analysis of dissolved solids, contaminants, dissolved oxygen, and
            the presence of life forms. Clean water supporting diverse organisms is rated highly, ensuring that healthy
            aquatic ecosystems are indicated to investors through high EcoScores.
          </>
        ),
      },
      { subtitle: { id: "sub45", text: "Air and forest health; the central factor in carbon sequestration" } },
      {
        paragraph: (
          <>
            In order to sequester carbon and clean the air, a healthy forest is essential. When assessing this factor in
            a land, we evaluate ecosystem services and photosynthetic biomass in order to measure the land's ability to
            sequester carbon and produce biomass. High carbon sequestration rates and substantial biomass scores
            indicate lands that significantly contribute to climate mitigation. Older forests with continuous canopy
            cover score high, indicating stability and high ecological value, assuring investors of long-term forest
            health.
          </>
        ),
      },
      { subtitle: { id: "sub46", text: "Biodiversity: a key indicator of ecological health" } },
      {
        paragraph: (
          <>
            This component is assessed through flora and fauna evaluations. Flora diversity measures the variety of
            plant species, including trees and non-woody plants. High diversity, particularly in primary forests with
            ancient trees, signals a robust ecosystem with high ecological value. It also considers impervious land use;
            essentially, how much of the soil is covered by hard surfaces, which impacts plant growth. Lands with
            minimal impervious surfaces score high, signalling healthy, vibrant ecosystems rich with flora—exactly what
            eco-conscious investors should invest in.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Fauna biodiversity measures species richness (alpha biodiversity) and population changes (beta
            biodiversity). Lands with a high number of species and keystone species score high, making sure the
            investments are supporting richly biodiverse ecosystems.
          </>
        ),
      },
      { subtitle: { id: "sub47", text: "Community: the people keeping ecologies alive" } },
      {
        paragraph: (
          <>
            When assessing a land's EcoScore, we also consider the socio-economic standing of local communities who
            depend on the land for their livelihoods. To do this, we look into what kind of employment opportunities are
            created in local communities on or around these lands. Lands providing more support for local communities
            score high, promoting socio-economic sustainability alongside ecological health.
          </>
        ),
      },
      { subtitle: { id: "sub48", text: "EcoScore brings transparent proof of value to investors and landowners" } },
      {
        paragraph: (
          <>
            It's time to end the current paradigm of short-sighted valuation based on commercial viability and switch to
            a longer-term vision that emphasizes real ecological value. EcoFutures is leading this change, and the
            radical transparency provided by a land's EcoScore allows investors to add lands to their crypto portfolio
            with confidence. For landowners, (termed Guardians once they get verified into the EcoFutures system)
            EcoScore is a reflection of a fair and accurate appraisal of their land's ecological value. By listing their
            land on the EcoFutures platform, they contribute to global sustainability efforts, gain access to annual
            rewards, and join a community of environmentally conscious investors. Our thorough assessment process
            guarantees that the ecological contributions of their land are recognized and fairly valued.
          </>
        ),
      },
      { subtitle: { id: "sub49", text: "EFTs are more than just investment vehicles..." } },
      {
        paragraph: (
          <>
            They are tools for advocacy.They're part of a growing crypto movement that calls for more meaningful
            investment.Right now, as the world faces unprecedented climate change, few causes are as important as those
            influencing ecological and environmental sustainability.With EFTs, investors and Guardians not only benefit
            financially, but also become active players in environmental stewardship in an age where every action
            counts.
          </>
        ),
      },
      {
        banner: {
          link: "/support-center?blog=blog-article-5",
          linkText: "Read the article",
          header: "Considering buying your own EFT ?",
          body: "Here are the key reasons why EFTs are poised to appreciate within the next decade, making them a great investment aligned with the urgent need for protecting ecologies.",
          color: "#ffffff",
          backgroundColor: "#955027",
        },
      },
    ],
  },
  "blog-article-5": {
    title: "Five Great Reasons to Invest in EcoFutures Tokens (EFTs)",
    thumbnail: { url: Valley, by: "Gez Xavier Mansfield" },
    updated: "Sep 11, 2024",
    blogId: "blog5",
    category: "Portfolio",
    data: [
      { subtitle: { id: "summary", text: "Summary:" } },
      {
        paragraph: (
          <ul>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub53");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Ecological Scarcity Leads to Increased Ecological Value
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub54");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Crypto Investors are Hungry for Meaningful Investments
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub55");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              {" "}
              The best of both worlds
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub56");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Ecological value vs. commercial real estate
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub57");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              Early adopters get more
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                const element = document.getElementById("sub58");
                if (element) {
                  const elementRect = element.getBoundingClientRect();
                  const absoluteElementTop = elementRect.top + window.pageYOffset;
                  window.scrollTo({
                    top: absoluteElementTop - 40, // Changed to fixed 40px offset
                    behavior: "smooth",
                  });
                }
              }}
            >
              EcoFutures Gives you a Stake in Sustaining Ecological Assets
            </li>
          </ul>
        ),
      },
      {
        image: {
          url: Blog5_1,
          by: "Image by Nipun Meegoda",
          title: "Five Great Reasons to Invest in EcoFutures Tokens(EFTs)",
          body: " ",
          bodyColor: "#2b3501",
        },
      },
      { subtitle: { id: "sub51", text: "Introduction" } },
      {
        paragraph: (
          <>
            EcoFutures Tokens (EFTs) are green asset-backed NFTs pegged to the intrinsic value of natural ecological
            assets, such as small jungles, permaculture farms, or nature reserves, rather than traditional commercial
            real estate. By valuing ecology in an age where natural environments are growing more and more scarce,
            EcoFutures are poised to usher in a revolutionary union of capitalist and conservationist interests.
          </>
        ),
      },
      {
        paragraph: (
          <>
            The money invested in EFTs goes directly toward supporting natural environments and the communities that
            sustain them, and as the ecological value of an EFT land increases, so does the ROI for investors. Taking
            this into consideration, as well as the fact that Earth's precious natural riches depend on our stewardship,
            it is clear to see that EcoFutures are one of the more meaningful investment opportunities available to
            conscientious investors.
          </>
        ),
      },
      {
        subtitle: {
          id: "sub52",
          text: "Here are five key reasons why EcoFutures are a great investment that aren't only aligned with the urgent need for protecting ecologies, but are also poised to increase in value over the next decade:",
        },
      },
      {
        image: {
          url: Blog5_2,
          by: (
            <>
              Deforestation in Bolivia
              <br />
              Before and after 1986 - 2022
              <br />
              Source: climate.nasa.gov
            </>
          ),
        },
      },
      { subtitle: { id: "sub53", text: "1 - Ecological Scarcity Leads to Increased Ecological Value" } },
      {
        paragraph: (
          <>
            EcoFutures are banking on increasing ecological values of natural environments as they get rarer due to
            deforestation, overpopulation, overconsumption, and waste—terrible habits that we can bet humanity won't
            shed in the next decade. While this truth is unfortunate, it is also valuable to EFT investors, as EFTs
            stand to increase in value proportionately to the real-world assets they're pegged to.
          </>
        ),
      },
      { subtitle: { id: "sub54", text: "2 - Crypto Investors are Hungry for Meaningful Investments" } },
      {
        paragraph: (
          <>
            A growing number of people in the crypto space are looking for more meaningful investment opportunities
            instead of yet another meme coin; EcoFutures give them precisely that. Like with all worthwhile asset-backed
            NFTs, investment opportunity and potential appreciation are the key benefits of early adoption when it comes
            to EFTs. There's a lot of room for appreciation and a bull market development within the next two decades.
          </>
        ),
      },
      { subtitle: { id: "sub55", text: "3 - The best of both worlds" } },
      {
        paragraph: (
          <>
            Like all strategically linked, asset-backed NFTs, EcoFutures have greater stability, higher liquidity and
            reliability that many purely speculative cryptocurrencies lack. They're the best of both worlds, connecting
            the tangible value of the physical asset with the flexibility and efficiency of digital currency. EFTs offer
            instantaneous transferability and accessibility, coupled with the enduring worth of easements to land
            assets.With each EFT serving as a digital representation of a real-world asset's ecology, they maintain a
            stable value, shielding investors from wild fluctuations as they wait for long-term returns.
          </>
        ),
      },
      {
        image: {
          url: Blog5_3,
          by: "Image by Tom Nicholson",
        },
      },
      { subtitle: { id: "sub56", text: "4 - Ecological value vs. commercial real estate" } },
      {
        paragraph: (
          <>
            EcoFutures have a marked difference from real estate-backed NFTs: they're pegged to the ecological value of
            a property, rather than its commercial value.The ecological value of each EFT is{" "}
            <a href="/support-center?blog=blog-article-1">scientifically assessed</a> by our third-party Trustees
            <sup>[1]</sup> and given an{" "}
            <a href="/support-center?blog=blog-article-4">
              {" "}
              EcoScore based on the quality of its soil, water, air, biodiversity, and community.
            </a>
            This means that when it comes to ecological value, a car park in downtown Los Angeles, USA—although high in
            commercial value—would score low compared to a rainforest in Ratnapura, Sri Lanka.
          </>
        ),
      },
      {
        glossary: [
          {
            term: "Trustee",
            definition: "Certified entities, that serve as third-party validators, as well as real- world oracles",
          },
        ],
      },
      { subtitle: { id: "sub57", text: "5 - Early adopters get more" } },
      {
        paragraph: (
          <>
            For early adopters buying into EcoFutures while the currency mint rate is high, there will be exponential
            potential for profits and growth as EFTs increase in value with the growing rarity of natural lands.In
            addition to the appreciation of EFTs, there's an incredible opportunity for those who get in on the ground
            floor, because the mint rate of TREEs decreases as the total land on the platform grows.
          </>
        ),
      },
      {
        paragraph: (
          <>
            Each time the EcoFutures protocol reaches its next Fibonacci-based edition threshold, a halving event occurs
            on the blockchain, reducing the number of new TREEs created and increasing their value, making early stakes
            more profitable.
          </>
        ),
      },
      {
        banner: {
          link: "/support-center?blog=blog-article-1",
          linkText: "Read the full article",
          header:
            "With all these factors combined, the returns for early adopters of EFTs appear incredibly promising.",
          body: "Want to learn more about TREEs?",
          color: "#ffffff",
          backgroundColor: "#2b3501",
          backgroundImage: Blog5_4,
          by: "Image by Xavier Mansfield",
        },
      },
      { subtitle: { id: "sub58", text: "EcoFutures Gives you a Stake in Sustaining Ecological Assets" } },
      {
        paragraph: (
          <>
            EFTs offer a fresh take on investments, adding more meaning to stakes beyond financial gain. For many,
            waiting for policies to protect the carbon sink and limit deforestation isn't an option; taking immediate
            action at an individual level is urgent. With EcoFutures, acting on climate change and protecting the
            natural world gets democratized. Now, you don't have to quit your job, move somewhere remote, and manage a
            forest; we can all pitch in to do it together. There has never been a better time to invest in preserving
            ecologies, and EcoFutures makes it possible for everyone, with room for some green profits on the side.
          </>
        ),
      },
      {
        banner: {
          list: (
            <>
              <ul>
                <li style={{ cursor: "pointer", textDecoration: "underline" }}>
                  Read the EcoFutures (EFTs) whitepaper and see why these NFTs are among the most meaningful investments
                  you can make.
                </li>
                <li style={{ cursor: "pointer", textDecoration: "underline" }}>
                  Read this research paper to understand why protecting ecological assets that are carbon sinks—like
                  forests, woodlands, water bodies and oceans—is the ultimate climate action.
                </li>
                <li
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => {
                    window.location.href = "/support-center?blog=blog-article-2";
                  }}
                >
                  Learn more about EcoFutures Trustees, who scientifically assess EFT lands and assign them an EcoScore
                  based on their ecological value
                </li>
              </ul>
            </>
          ),
          header: "Do your own research",
          body: "We have plenty of resources available for discerning investors to learn more about the EcoFutures platform, as well as the urgency of taking environmental action: ",
          color: "#000000",
          backgroundColor: "#d1efff",
        },
      },
    ],
  },
  "blog-article-how-to": {
    title: "List of How-To articles",
    category: "EcoFutures",
    blogId: "blog6",
    thumbnail: { url: Trustee, by: "Forrest Cavale" },
    updated: "Feb 18, 2025",
    data: [
      { subtitle: { id: "summary", text: "List of how-to article" } },
      {
        paragraph: (
          <ul>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                window.open(
                  "https://support.metamask.io/start/getting-started-with-metamask/",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              Getting started with MetaMask
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                window.open(
                  "https://support.metamask.io/start/getting-started-with-metamask/#:~:text=to%20%22Next%20Steps%22.-,How%20to%20install,-MetaMask%3A%E2%80%8B",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              How to install MetaMask
            </li>
            <li
              style={{ cursor: "pointer" }}
              onClick={() => {
                window.open(
                  "https://support.metamask.io/start/user-guide-secret-recovery-phrase-password-and-private-keys/",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              User Guide: Secret Recovery Phrase, password, and private keys
            </li>
            <li
              onClick={() => {
                window.open(
                  "https://support.metamask.io/start/learn/whats-the-difference-between-a-wallet-and-an-account-/#:~:text=mean%20in%20practice%3F-,%E2%80%8B,are%20managed%20using%20your%20wallet",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              What's the difference between a wallet and an account?
            </li>
            <li
              onClick={() => {
                window.open(
                  "https://support.metamask.io/start/how-to-transfer-assets-from-centralized-exchange/#:~:text=guide%20here.-,Transfer%20CEX,-assets%20to%20MetaMask",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              How to transfer assets from a centralized exchange to MetaMask
            </li>
            <li
              onClick={() => {
                window.open(
                  "https://support.metamask.io/manage-crypto/move-crypto/bridge/how-to-use-the-bridge/",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              How to use the bridge
            </li>
            <li
              onClick={() => {
                window.open(
                  "https://support.metamask.io/manage-crypto/move-crypto/swap/user-guide-swaps/",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              User Guide: Swaps
            </li>
            <li
              onClick={() => {
                window.open(
                  "https://support.metamask.io/start/how-to-contact-metamask-support/",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              How to contact MetaMask Support
            </li>
            <li
              onClick={() => {
                window.open(
                  "https://ecofutures.io/support-center?blog=blog-article-2",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              How to become an EcoScore Trustee
            </li>
            <li
              onClick={() => {
                window.open("", "_blank", "noopener,noreferrer");
              }}
            >
              How to be come a EcoScore Guardian
            </li>
            <li
              onClick={() => {
                window.open("", "_blank", "noopener,noreferrer");
              }}
            >
              How to auction my EcoFutures token
            </li>
          </ul>
        ),
      },
    ],
  },
};

export default { blogs, posters };
